export const DEPROP1_PI_TAG = "PI_CAL\\SAR.fic405.pv"
export const DEPROP2_PI_TAG = "PI_CAL\\SAR.fic406.pv"
export const DEPROP3_PI_TAG = "PI_CAL\\SAR.fic407.pv"
export const DEPROP4_PI_TAG = "PI_CAL\\SAR.fic600.pv"
export const DEBUT1_PI_TAG = "PI_CAL\\SAR.fic1720.pv"
export const DEBUT3_PI_TAG = "PI_CAL\\SAR.fic1721.pv"
export const DEBUT4_PI_TAG = "PI_CAL\\SAR.fic1722.pv"
export const SPLITTER1_PI_TAG = "PI_CAL\\SAR.fic26.pv"
export const SPLITTER3_PI_TAG = "PI_CAL\\SAR.fic422.pv"
export const SPLITTER4_PI_TAG = "PI_CAL\\SAR.fic613.pv"
export const SPLITTER6_PI_TAG = "PI_CAL\\SAR.fic1011.pv"
export const UPGRADER_PI_TAG = "PI_CAL\\SAR.fic1633.pida.pv"

export const PI_TAGS = [
    DEPROP1_PI_TAG.split("\\")[1],
    DEPROP2_PI_TAG.split("\\")[1],
    DEPROP3_PI_TAG.split("\\")[1],
    DEPROP4_PI_TAG.split("\\")[1],
    DEBUT1_PI_TAG.split("\\")[1],
    DEBUT3_PI_TAG.split("\\")[1],
    DEBUT4_PI_TAG.split("\\")[1],
    SPLITTER1_PI_TAG.split("\\")[1],
    SPLITTER3_PI_TAG.split("\\")[1],
    SPLITTER4_PI_TAG.split("\\")[1],
    SPLITTER6_PI_TAG.split("\\")[1],
    UPGRADER_PI_TAG.split("\\")[1]
]